import React from "react";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <div style={{ marginRight: "4px", marginBottom: "3px" }}>
                <img
                  src="img/Condor-andino.jpg"
                  className="img-responsive"
                  alt=""
                  style={{ maxHeight: "40px", maxWidth: "100%" }}
                />
              </div>
              <div style={{ textAlign: "center", fontSize: "0.8em", lineHeight: "1em" }}>
                Condor andino seguridad
              </div>
            </div>
          </a>
        </div>

        <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#features" className="page-scroll">
                Caracteristicas
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
                Misión y Visión
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll">
                Servicios
              </a>
            </li>
            <li>
              <a href="#portfolio" className="page-scroll">
                Galeria
              </a>
            </li>
            <li>
              <a href="#testimonials" className="page-scroll">
                Testimonios
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Contacto
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};